// const BASEURL = 'http://localhost:8000';
const BASEURL = 'https://macky-ecom-server.onrender.com';

// eslint-disable-next-line import/prefer-default-export
export { BASEURL };
